import { createStyleSheet, rh, rw } from '@shared-ui/theme'

export const useCreateStyles = createStyleSheet((theme, { safe }) => ({
  wrapperTop: {
    position: 'absolute',
    left: theme.SIZE_CONTAINER_PADDING,
    right: theme.SIZE_CONTAINER_PADDING,
    zIndex: 100,
    marginTop: rh(10),
    top: safe.top || rh(20),
    alignItems: 'center',
  },
  animPos: {
    position: 'absolute',
    left: 0,
    right: 0,
    alignItems: 'center',
  },
  animInner: {
    alignSelf: 'center',
    maxWidth: '100%',
    alignItems: 'center',
  },
  block: {
    alignSelf: 'center',
    maxWidth: '100%',
    minHeight: rh(40),
    paddingHorizontal: rw(16),
    borderRadius: rw(theme.SIZE_BUTTON_BORDER_RADIUS),
    marginBottom: rw(10),
    flexDirection: 'row',
    alignItems: 'center',
    gap: rw(4),
    backgroundColor: theme.COLOR_BG_INVERSE,
    boxShadow: [
      {
        offsetX: 0,
        offsetY: rh(8),
        color: 'rgba(0, 0, 0, 0.08)',
        blurRadius: 13,
      },
    ],
  },
  blockWeb: {
    pointerEvents: 'auto',
  },
  side: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    flexGrow: 0,
    flexShrink: 1,
    textAlign: 'center',
  },
  appIcon: {
    color: theme.COLOR_ICON_INVERSE,
    width: rw(24),
  },
  appIconSuccess: {
    color: theme.COLOR_ICON_INVERSE,
  },
  appIconInfo: {
    color: theme.COLOR_ICON_INVERSE,
  },
  appIconError: {
    color: theme.COLOR_ICON_INVERSE,
  },
}))
